import { DividendCalendarTile } from "../DividendCalendarTile.js";

export function DividendCalendarWidget() {
  return <DividendCalendarTile />;
}
